module.exports = __webpack_public_path__ + "static/media/hamMenu.14eee2ce.png";